import { render, staticRenderFns } from "./OrganizationImport.vue?vue&type=template&id=33a6bf02&"
import script from "./OrganizationImport.vue?vue&type=script&lang=js&"
export * from "./OrganizationImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports